import { createAction } from 'redux-actions'

export const actionLoadingName = actionType => `${actionType}_REQUEST_LOADING`
export const actionSuccessName = actionType => `${actionType}_REQUEST_SUCCESS`
export const actionErrorName = actionType => `${actionType}_REQUEST_ERROR`
const makeAction = actionType => ({ [actionType]: actionType })
const makeActionWithRequest = actionType => ({
  [actionType]: actionType,
  [actionLoadingName(actionType)]: actionLoadingName(actionType),
  [actionSuccessName(actionType)]: actionSuccessName(actionType),
  [actionErrorName(actionType)]: actionErrorName(actionType),
})

export const Actions = {
  ...makeAction('APP_START'),
  ...makeActionWithRequest('LOG_IN'),
  ...makeActionWithRequest('GET_USER'),
  ...makeAction('LOG_OUT'),
  ...makeActionWithRequest('GET_AGENDAS'),
  ...makeAction('SELECT_AGENDA'),
  ...makeActionWithRequest('GET_AGENDA_REPORT'),
  ...makeActionWithRequest('GET_AGENDA_WEEK_APPOINTMENTS'),
  ...makeActionWithRequest('CREATE_APPOINTMENT'),
  ...makeActionWithRequest('CLOSE_APPOINTMENT'),
  ...makeActionWithRequest('CLOSE_ALL_APPOINTMENTS_FOR_DAY'),
  ...makeActionWithRequest('OPEN_APPOINTMENT'),
  ...makeAction('PROMPT_COMPLETE_APPOINTMENT'),
  ...makeActionWithRequest('COMPLETE_APPOINTMENT'),
  ...makeAction('PROMPT_CANCEL_APPOINTMENT'),
  ...makeActionWithRequest('CANCEL_APPOINTMENT'),
  ...makeAction('PROMPT_DIALOG_CLOSE'),
  ...makeActionWithRequest('GET_TELEHEALTH_APPOINTMENT_CREDENTIALS'),
  ...makeAction('CLEAR_TELEHEALTH_APPOINTMENT_CREDENTIALS'),
}

export const appStart = createAction(Actions.APP_START)
export const logIn = createAction(Actions.LOG_IN)
export const logOut = createAction(Actions.LOG_OUT)
export const getAgendas = createAction(Actions.GET_AGENDAS)
export const getAgendaReport = createAction(Actions.GET_AGENDA_REPORT)
export const getAgendaWeekAppointments = createAction(Actions.GET_AGENDA_WEEK_APPOINTMENTS)
export const selectAgenda = createAction(Actions.SELECT_AGENDA)
export const createAppointment = createAction(Actions.CREATE_APPOINTMENT)
export const closeAppointment = createAction(Actions.CLOSE_APPOINTMENT)
export const closeAllAppointmentsForDay = createAction(Actions.CLOSE_ALL_APPOINTMENTS_FOR_DAY)
export const openAppointment = createAction(Actions.OPEN_APPOINTMENT)
export const promptCompleteAppointment = createAction(Actions.PROMPT_COMPLETE_APPOINTMENT)
export const completeAppointment = createAction(Actions.COMPLETE_APPOINTMENT)
export const promptCancelAppointment = createAction(Actions.PROMPT_CANCEL_APPOINTMENT)
export const cancelAppointment = createAction(Actions.CANCEL_APPOINTMENT)
export const promptDialogClose = createAction(Actions.PROMPT_DIALOG_CLOSE)
export const getTelehealthAppointmentCredentials = createAction(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS)
export const clearTelehealthAppointmentCredentials = createAction(Actions.CLEAR_TELEHEALTH_APPOINTMENT_CREDENTIALS)



// WEBPACK FOOTER //
// ./src/state/actions.js